import Logo, { LogoType } from '@doordash/component-logo';
import { InlineChildren, InlineChildrenAlignment, Inset, InsetSize, StackChildren, StackChildrenSize, Text, TextColor, TextStyle, } from '@doordash/design-language';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { PORTAL_ROUTE_PREFIX } from '../../constants/values';
import { HeaderRoot } from './HeaderStyles';
import { LayoutTestId } from '../Common/testId';
import { IconButton } from '@doordash/component-button';
export var Header = function (_a) {
    var teamName = _a.teamName, _b = _a.link, link = _b === void 0 ? PORTAL_ROUTE_PREFIX : _b, _c = _a.isOpenInNewTab, isOpenInNewTab = _c === void 0 ? false : _c, _d = _a.isFullPageHeader, isFullPageHeader = _d === void 0 ? false : _d, _e = _a.onClose, onClose = _e === void 0 ? null : _e;
    var history = useHistory();
    var navigateToLink = function () {
        if (isOpenInNewTab) {
            return window.open(link, '_blank');
        }
        return history.push(link);
    };
    return (React.createElement(HeaderRoot, { isFullPageHeader: isFullPageHeader },
        React.createElement(Inset, { verticalSize: InsetSize.Small, horizontalSize: InsetSize.Large },
            React.createElement(InlineChildren, { justifyContent: InlineChildren.Justification.SpaceBetween, alignItems: InlineChildrenAlignment.Center },
                React.createElement(StackChildren, { size: StackChildrenSize.XxxSmall },
                    React.createElement("div", { "data-testid": LayoutTestId.LogoContainer, onClick: navigateToLink },
                        React.createElement(Logo, { type: LogoType.Logo })),
                    React.createElement(Text, { color: TextColor.TextTertiary, styles: TextStyle.Body1 }, teamName ? "Admin Portal for " + teamName : 'Admin Portal')),
                onClose && (React.createElement(IconButton, { accessibilityLabel: 'close', iconType: IconButton.IconTypes.Close, onClick: onClose }))))));
};
export default Header;
